import React, { useEffect, useState } from "react";
import Popup from "../Popup";
import FormHeader from "../form/Header";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../utils/formatDate";
import { LoadingIcon } from "../../assets/icons/Icons";
import { GetMfaBalance } from "../../api/program/getMfaBalance";
import Amount from "../Amount";

const ViewProgram = ({ program, onClose, ...props }) => {
  const { t } = useTranslation();
  const [loading, setloading] = useState(false);
  const [programDetail, setprogramDetail] = useState(null);
  const fetchOrder = async (id) => {
    setloading(true);
    const orderDetails = await GetMfaBalance(program.id);
    setprogramDetail(orderDetails?.data ?? null);
    setloading(false);
  };
  useEffect(() => {
    if (program?.id && !programDetail) {
      fetchOrder(program?.id);
    }
    return () => {
      setprogramDetail(null);
      setloading(false);
    };
    // eslint-disable-next-line
  }, [program]);
  return (
    <Popup size="large" withClose withOverlay onClose={onClose}>
      <FormHeader title={`Program ID: ${program.id}`}></FormHeader>

      <div className="mt-5">
        <table className="table">
          <tbody>
            <tr>
              <td>{t("Company ID")}:</td>
              <td className="w-100">
                <strong>{program?.company_id}</strong>
              </td>
            </tr>
            <tr>
              <td>{t("Program Name")}:</td>
              <td>
                <strong>{program?.name}</strong>
              </td>
            </tr>
            <tr>
              <td>{t("Direct Deposit Account")}:</td>
              <td>
                <strong>
                  {program?.direct_deposit_account ? "Enabled" : "Disabled"}
                </strong>
              </td>
            </tr>
            <tr>
              <td>{t("Master Funding Account Number")}:</td>
              <td>
                <strong>{program?.master_funding_account_number}</strong>
              </td>
            </tr>
            <tr>
              <td>{t("Master Funding Account Balance")}:</td>
              <td>
                {loading ? (
                  <div style={{ width: "20px", height: "20px" }}>
                    <LoadingIcon />
                  </div>
                ) : (
                  <strong>
                    {loading ? (
                      "Fetching Balance..."
                    ) : programDetail?.balance ? (
                      <Amount
                        amount={programDetail?.balance ?? 1231}
                        currency={
                          programDetail?.balance === "840" ? "USD" : "CAD"
                        }
                      />
                    ) : (
                      "NA"
                    )}
                  </strong>
                )}
              </td>
            </tr>
            <tr>
              <td>{t("Status")}:</td>
              <td>
                <strong>{program?.status}</strong>
              </td>
            </tr>
            <tr>
              <td>{t("Created At")}:</td>
              <td>
                <strong>{formatDate(program?.created_at)}</strong>
              </td>
            </tr>
            <tr>
              <td>{t("Updated At")}:</td>
              <td>
                <strong>{formatDate(program?.updated_at)}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Popup>
  );
};

export default ViewProgram;
